import { cva } from 'class-variance-authority';

export const filterDropdownContentVariants = cva(
	'top-[52px] mt-3 w-[25rem] flex-col overflow-visible p-5 transition-all duration-300 ease-in-out md:top-[58px] border',
	{
		variants: {
			variant: {
				primary: 'border-white-dark-3 bg-white text-primary',
				dark: 'border-primary-light-3 bg-primary text-white-dark-4',
				black: 'border-primary-light-3 bg-black text-white-dark-4'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);
